var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacePledgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "32 0 300 44",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Place Pledge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 27,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 950,
    letterSpacing: 8,
    textAnchor: "end"
  }, "PLACE"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 0)",
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5 29.5l7.2-4.1 7.2 4.1 6.6-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7 25.4V13.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.9 29.5V16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 9.5c-3.6 0-6.5 2.9-6.5 6.4 0 5.1 6.5 10.2 6.5 10.2s6.5-5.1 6.5-10.2c0-3.5-2.9-6.4-6.5-6.4Z",
    fill: "#111827"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 15.9,
    r: 2,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 27,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 950,
    letterSpacing: 8
  }, "PLEDGE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacePledgeLogo);
export default __webpack_public_path__ + "static/media/place-pledge-logo.64797a460aaf94b95eb86d1edd3e4006.svg";
export { ForwardRef as ReactComponent };